import { errorToastMessage, successToastMessage } from "utils/errorToast";
import {
  LOADER_STATUS,
  SET_SELECTED_NOTES,
  SET_SELECTED_ROW_NOTES,
  SET_TABLE_DATA,
  SET_ENTITY_MASTER_LIST,
  SET_DEFAULT_ENTITY,
  SET_PROFILE_DATA,
  SET_SELECTED_GSTIN,
  SET_SELECTED_PERIODS,
  SET_OPEN_ADD_NOTES,
  SET_TOTAL_PAGES,
  SET_SELECTED_MODULE,
  SET_SELECTED_CATEGORY,
  SET_SEARCH,
  SET_COMMENT_TABLE_DATA,
  SET_FILES_DATA,
  SET_NOTES_HEADING_DATA,
} from "./constants";
import { getLocalStorage } from "components/Helper/Helper.js";
import { Config } from "../../../Config.js";
import axios from "axios";
import { SET_MODULE_IDS } from "./constants";

export function loader(status) {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
}

export function setSelectedNotes(selected) {
  return {
    type: SET_SELECTED_NOTES,
    selectedNotes: selected,
  };
}

export function setSelectedRowNotes(selectedRow) {
  return {
    type: SET_SELECTED_ROW_NOTES,
    selectedRowNotes: selectedRow,
  };
}

export function setTableData(tableData) {
  return {
    type: SET_TABLE_DATA,
    tableData: tableData,
  };
}

// Entity and GSTIN related actions
export function setEntityMasterList(entityList) {
  return {
    type: SET_ENTITY_MASTER_LIST,
    entityMasterList: entityList,
  };
}

export function setDefaultEntity(entity) {
  return {
    type: SET_DEFAULT_ENTITY,
    defaultEntity: entity,
  };
}

export function setProfileData(profileData) {
  return {
    type: SET_PROFILE_DATA,
    profileData: profileData,
  };
}

export function setSelectedGstin(selectedGstin) {
  return {
    type: SET_SELECTED_GSTIN,
    selectedGstin: selectedGstin,
  };
}

export function setSelectedPeriods(selectedPeriods) {
  return {
    type: SET_SELECTED_PERIODS,
    selectedPeriods: selectedPeriods,
  };
}

export function setOpenAddNotes(openAddNotes) {
  return {
    type: SET_OPEN_ADD_NOTES,
    openAddNotes: openAddNotes,
  };
}

export function setModuleIds(moduleIds) {
  return {
    type: SET_MODULE_IDS,
    moduleIds: moduleIds,
  };
}

export function setTotalPages(totalPages) {
  return {
    type: SET_TOTAL_PAGES,
    totalPages: totalPages,
  };
}

export function setSelectedModule(selectedModule) {
  return {
    type: SET_SELECTED_MODULE,
    selectedModule: selectedModule,
  };
}

export function setSelectedCategory(selectedCategory) {
  return {
    type: SET_SELECTED_CATEGORY,
    selectedCategory: selectedCategory,
  };
}

export function setSearch(search) {
  return {
    type: SET_SEARCH,
    search: search,
  };
}

export function setCommentTableData(commentTableData) {
  return {
    type: SET_COMMENT_TABLE_DATA,
    commentTableData: commentTableData,
  };
}

export function setFilesData(filesData) {
  return {
    type: SET_FILES_DATA,
    filesData: filesData,
  };
}

export function setNotesHeadingData(notesHeadingData) {
  return {
    type: SET_NOTES_HEADING_DATA,
    notesHeadingData: notesHeadingData,
  };
}

// API calls

// API Call: Fetches the list of all available entities/companies for the logged-in user
export const getEntityList = () => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_GET_ENTITY_LIST = `${Config.url}console/getCompanyByUserId`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const data = {
      user_id: getLocalStorage("user_id").user_id,
    };
    try {
      const response = await axios({
        method: "post",
        url: URL_GET_ENTITY_LIST,
        headers: headers,
        data: data,
      });
      if (response.data?.error === 0) {
        let entityList = response.data.data.map((entity) => {
          return { value: entity.company_id, label: entity.name };
        });

        dispatch(setEntityMasterList(entityList));
        return entityList;
      } else {
        dispatch(setEntityMasterList([]));
        errorToastMessage(
          response.data.message || "Error while fetching entity list"
        );
        return [];
      }
    } catch (err) {
      errorToastMessage("Error while fetching entity list");
      console.log(`Error in getEntityList: ${err}`);
      dispatch(setEntityMasterList([]));
      return [];
    } finally {
      dispatch(loader(false));
    }
  };
};

// API Call: Fetches all GSTIN numbers associated with a specific entity/company
export const getGstinByEntity = (entityId) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_GET_GSTIN_BY_ENTITY = `${Config.url}console/getGstnListByEntityId`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const data = {
      entity_id: entityId,
      user_id: getLocalStorage("user_id").user_id,
    };
    try {
      const response = await axios({
        method: "post",
        url: URL_GET_GSTIN_BY_ENTITY,
        headers: headers,
        data: data,
      });
      if (response.data?.error === 0) {
        if (response.data.error !== 1) {
          const gstinList = response.data?.data || [];

          const sortedGstin = gstinList.sort((a, b) =>
            a.gstin > b.gstin ? 1 : -1
          );
          dispatch(setProfileData(sortedGstin));
          return sortedGstin;
        }
      } else {
        dispatch(setProfileData([]));
        errorToastMessage(
          response.data.message || "Error while fetching GSTIN list"
        );
        return [];
      }
    } catch (err) {
      errorToastMessage("Error while fetching GSTIN list");
      console.log(`Error in getGstinByEntity: ${err}`);
      dispatch(setProfileData([]));
      return [];
    } finally {
      dispatch(loader(false));
    }
  };
};

// API Call: Fetches notes data based on selected filters and search criteria
export const getNotesData = (
  selectedGstin,
  selectedModule,
  selectedEntity,
  selectedCategory,
  selectedPeriods,
  search,
  pageNo,
  isToast
) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_GET_NOTES_DATA = `${Config.url}notes/list`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };
    const data = {
      gstins: selectedGstin,
      moduleCode: selectedModule,
      entityId: selectedEntity,
      category: selectedCategory,
      periods: selectedPeriods, // Changed from period to periods for multi-select
      search: search || "",
      pageNo: pageNo || 1,
      limit: 10,
    };

    try {
      const response = await axios({
        method: "post",
        url: URL_GET_NOTES_DATA,
        headers: headers,
        data: data,
      });
      if (response.data?.error === 0) {
        if (isToast)
          successToastMessage(
            response?.data?.message || "Data fetched successfully"
          );
        const totalRecords = response.data.data?.pagination?.totalRecords || 0;
        dispatch(setTotalPages(Math.ceil(totalRecords / 10)));
        dispatch(setTableData(response.data.data.notes));
        return response.data.data.notes;
      } else {
        dispatch(setTableData([]));
        if (isToast)
          errorToastMessage(
            response.data.message || "Error while fetching data"
          );
        return [];
      }
    } catch (err) {
      errorToastMessage("Error while fetching data");
      console.log(`Error in getNotesData: ${err}`);
      dispatch(setTableData([]));
      return [];
    } finally {
      dispatch(loader(false));
    }
  };
};

// API Call: Downloads notes data as Excel/ZIP file based on selected rows and filters
export const downloadNotesExcel = (selectedNotes) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_GET_DOWNLOAD_DATA = `${Config.url}notes/download/notes`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };

    const data = {
      note_ids: selectedNotes,
    };

    console.log("Data in downloadNotesExcel:", data);

    try {
      const response = await axios({
        method: "post",
        data: data,
        url: URL_GET_DOWNLOAD_DATA,
        headers: headers,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const now = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const timestamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
        now.getDate()
      )}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(
        now.getSeconds()
      )}`;
      const filename = `Notes_${timestamp}.zip`;
      console.log(filename);

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);

      successToastMessage("Notes data downloaded successfully");
    } catch (error) {
      console.log(`Error in downloadNotesExcel: ${error}`);
      errorToastMessage("Failed to download notes data");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getUserModules = () => {
  return async (dispatch) => {
    dispatch(loader(true));
    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}users/getUserMappingModules`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      if (response.data.error !== 1) {
        let { moduleId, subscribeStartDate, subscribeEndDate, module_name } =
          response.data.data;

let pindex=moduleId.indexOf(19)
moduleId.splice(pindex,1)
subscribeStartDate.splice(pindex,1)
subscribeEndDate.splice(pindex,1)
module_name.splice(pindex,1)


        const modifiedData =
          moduleId.length !== 0 &&
          moduleId.map((item, index) => ({
            ...item,
            moduleId: moduleId[index],
            subscribeStartDate: subscribeStartDate[index],
            subscribeEndDate: subscribeEndDate[index],
            module_name: module_name[index],
          }));

        const ids = modifiedData ? modifiedData.map((mod) => mod.moduleId) : [];
        // console.log("ids in redux::", ids);
        dispatch(setModuleIds(modifiedData));
      }

      return true;
    } catch (error) {
      console.log(error);
      throw error;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getViewNotesData = (noteId) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_GET_NOTE_DETAILS = `${Config.url}notes/note/${noteId}`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };

    try {
      const response = await axios({
        method: "get",
        url: URL_GET_NOTE_DETAILS,
        headers: headers,
      });
      if (response.data?.error === 0) {
        successToastMessage(
          response?.data?.message || "Note details fetched successfully"
        );
        // Store the complete note data in Redux
        dispatch(setNotesHeadingData(response.data?.data?.note || null));
        dispatch(setCommentTableData(response.data?.data?.comments || []));
        dispatch(setFilesData(response.data?.data?.files || []));
        return response.data.data;
      } else {
        errorToastMessage(
          response.data.message || "Error while fetching note details"
        );
        dispatch(setNotesHeadingData(null));
        dispatch(setCommentTableData([]));
        dispatch(setFilesData([]));
        return null;
      }
    } catch (err) {
      errorToastMessage("Error while fetching note details");
      console.log(`Error in getViewNotesData: ${err}`);
      return null;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const downloadAttachments = (selectedCategory, noteId, fileId) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_GET_DOWNLOAD_DATA = `${Config.url}notes/download/files`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };

    const data = {
      category: selectedCategory,
      note_id: noteId,
      file_ids: fileId,
    };

    console.log("Data in downloadNotesExcel:", data);

    try {
      const response = await axios({
        method: "post",
        data: data,
        url: URL_GET_DOWNLOAD_DATA,
        headers: headers,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const now = new Date();
      const pad = (n) => n.toString().padStart(2, "0");
      const timestamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
        now.getDate()
      )}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(
        now.getSeconds()
      )}`;
      const filename = `Attachments_${timestamp}.zip`;
      console.log(filename);

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);

      successToastMessage("Notes data downloaded successfully");
    } catch (error) {
      console.log(`Error in downloadNotesExcel: ${error}`);
      errorToastMessage("Failed to download notes data");
    } finally {
      dispatch(loader(false));
    }
  };
};

export const createNoteWithFiles = (noteData, files) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_CREATE_NOTE = `${Config.url}notes/create`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };

    // Create FormData for multipart/form-data
    const formData = new FormData();
    
    // Add note data fields
    formData.append('moduleCode', noteData.moduleCode);
    formData.append('category', noteData.category);
    formData.append('entityId', noteData.entityId);
    formData.append('heading', noteData.heading);
    formData.append('gstin', noteData.gstin);
    formData.append('periods', JSON.stringify(noteData.periods));
    formData.append('entityName', noteData.entityName);
    formData.append('moduleName', noteData.moduleName);

    // Debug: Log all FormData entries
    console.log('FormData contents:');
    for (let pair of formData.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }
    
    // Add files
    if (files && files.length > 0) {
      files.forEach((file, index) => {
        formData.append(`file${index + 1}`, file);
      });
    }

    try {
      const response = await axios({
        method: "post",
        url: URL_CREATE_NOTE,
        headers: headers,
        data: formData,
      });
      
      if (response.data?.error === 0) {
        successToastMessage(
          response?.data?.message || "Note created successfully"
        );
        return response.data.data;
      } else {
        errorToastMessage(
          response.data.message || "Error while creating note"
        );
        return null;
      }
    } catch (err) {
      errorToastMessage("Error while creating note");
      console.log(`Error in createNoteWithFiles: ${err}`);
      return null;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const addComment = (noteId, text) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const URL_ADD_COMMENT = `${Config.url}notes/note/${noteId}/comment`;
    const headers = {
      token: getLocalStorage("loginDetails"),
    };

    const data = {
      text: text
    };

    try {
      const response = await axios({
        method: "post",
        url: URL_ADD_COMMENT,
        headers: headers,
        data: data,
      });
      if (response.data?.error === 0) {
        successToastMessage(
          response?.data?.message || "Comment added successfully"
        );
        return response.data.data;
      } else {
        errorToastMessage(
          response.data.message || "Error while adding comment"
        );
        return null;
      }
    } catch (err) {
      errorToastMessage("Error while adding comment");
      console.log(`Error in addComment: ${err}`);
      return null;
    } finally {
      dispatch(loader(false));
    }
  };
};